import { createTheme, Theme } from '@material-ui/core/styles';

import defaultTheme from 'themes/getTheme/defaultTheme';
import {
  CLIENT_THEME_VARIANT_MAP,
  DEFAULT,
  ThemeVariantMapKey,
} from 'themes/getTheme/variants/index';

function getTheme(clientName: ThemeVariantMapKey = DEFAULT): Theme {
  const themeVariant = CLIENT_THEME_VARIANT_MAP[clientName] || CLIENT_THEME_VARIANT_MAP[DEFAULT];
  const { props, typography, overrides, palette } = themeVariant.spec;

  return createTheme({
    variantName: themeVariant.name,
    ...defaultTheme,
    props: { ...defaultTheme.props, ...props },
    typography: { ...defaultTheme.typography, ...typography },
    overrides: { ...defaultTheme.overrides, ...overrides },
    palette: { ...defaultTheme.palette, ...palette },
  });
}

export default getTheme;
